// extracted by mini-css-extract-plugin
export default {"container":"QA-z","dimension":"RA-z","dimensionLabels":"SA-z"};